import { moduleProviderFactory } from 'core/providers';
import { InventoryList } from 'application/inventory/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.inventory',
                pattern: '/inventory',
                children: [
                    {
                        name: 'master.app.main.inventory.list',
                        pattern: '',
                        tabTitle: 'INVENTORY.LIST.TITLE',
                        component: InventoryList,
                        authorization: 'pumpTrackingSection.read',                        
                        data: {
                            title: 'INVENTORY.LIST.TITLE'
                        }
                    }               
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.PUMPS',
                order: 8,
				icon: "pump",
                subMenu: [
                    {
                        title: 'MENU.INVENTORY',
                        route: 'master.app.main.inventory.list',
                        order: 2
                    }                    
                ]
            }
        ]        
    });
})();

